import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppState } from '../state/AppState';
import { createFindAnotherProviderHandler } from '../services/providerService';
import BackButton from '../components/BackButton';
import { formatPhoneForDisplay } from '../utils/phoneUtils';

/**
 * ScreenW - Option not listed screen.
 *
 * Displays an interface for users when their option is not listed, 
 * allowing them to call Mindful Therapy Group for assistance.
 */
const ScreenW: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useAppState();

  const handleFindAnotherProvider = createFindAnotherProviderHandler(state.stateString || undefined);
  
  return (
    <div className="screen-bg">
      <div className="main-content-container">
        <div className="mtg-back-btn-align">
          <BackButton onClick={() => navigate(-1)} />
        </div>
        <main className="mtg-screen-main">
          <div className="mtg-screen-card text-center">
            <h2 style={{ 
              color: '#185F93', 
              fontWeight: 700, 
              fontSize: '1.25rem',
              marginBottom: '1rem'
            }}>
              Option not listed.
            </h2>
            <div className="mb-24">
              <p style={{ 
                fontSize: '1.05rem', 
                color: '#333',
                lineHeight: '1.5',
                marginBottom: '1.5rem',
                textAlign: 'left',
                paddingLeft: '24px',
                paddingRight: '24px'
              }}>
                If your option is not listed it may be that we don't have availability that matches your criteria. Call us now and we will help find the best fit for your needs.
              </p>
              <div style={{ 
                fontSize: '1.6rem', 
                fontWeight: 700, 
                color: '#185F93',
                marginBottom: '0.5rem'
              }}>
                Call Us
              </div>
              <p style={{ 
                fontSize: '1.3rem', 
                color: '#185F93',
                fontWeight: 500
              }}>
                {formatPhoneForDisplay()}
              </p>
            </div>
            <div style={{ textAlign: 'left' }}>
              <button 
                className="pill-btn-standard"
                onClick={handleFindAnotherProvider}
                style={{
                  backgroundColor: '#185F93',
                  color: 'white',
                  border: 'none',
                  padding: '12px 24px',
                  borderRadius: '24px',
                  fontSize: '1rem',
                  fontWeight: 600,
                  cursor: 'pointer'
                }}
              >
                Find Another Provider
              </button>
            </div>
          </div>
        </main>
      </div>
    </div>
  );
};

export default ScreenW; 